<template>
  <div>
    <div>
      <NotificationBar />
      <div class="d-flex justify-content-start justify-content-md-between align-items-center flex-column flex-md-row">
        <h1 class="mr-auto">Customers</h1>
        <div class="mb-3 d-flex justify-content-start align-items-center">
          <b-button-group class="mr-2">
            <b-button to="/customers/create" class="btn btn-light intro-customer-new">New Customer</b-button>
            <b-dropdown right variant="light" class="intro-customer-import">
              <b-dropdown-item @click="showImport">Import CSV</b-dropdown-item>
            </b-dropdown>
          </b-button-group>
          <b-button-group class="mr-2">
            <b-button to="/customers/companies/create" class="btn btn-light intro-customer-new">New Company</b-button>
            <b-dropdown right variant="light" class="intro-customer-import">
              <b-dropdown-item @click="showImportCompany">Import CSV</b-dropdown-item>
            </b-dropdown>
          </b-button-group>
          <router-link
            to="/customers/presentations/create"
            class="btn btn-light ml-2 my-2 intro-customer-new-presentation"
            >New Presentation</router-link
          >
        </div>
      </div>
      <ul class="nav nav-tabs nav-tabs-underline mb-4">
        <li
          class="nav-item"
          v-for="tab in tabs"
          :key="tab.tab"
          :class="tab.class"
          v-b-popover.hover="
            !showUpgradePlanIcon(tab) && {
              content: toolTip,
              html: true
            }
          "
        >
          <router-link
            :to="tab.link"
            :class="{
              active: tab.link == currentTab || (tab.subTabs && tab.subTabs.some((st) => st.link === currentTab))
            }"
            class="nav-link text-nowrap"
          >
            <i :class="tab.icon" v-if="tab.icon" class="mr-2 d-none"></i>
            <span :class="!showUpgradePlanIcon(tab) && 'text-muted'">{{ tab.name }}</span>
            <i v-if="!showUpgradePlanIcon(tab)" class="fas fa-circle fa-xs text-primary position-absolute ml-1"></i>
            <span v-if="tab.badge" class="badge badge-pill badge-primary ml-2 d-inline-block">{{ tab.badge }}</span>
          </router-link>
        </li>
      </ul>
      <ul v-if="subTabs" class="nav nav-tabs nav-tabs-underline mb-4">
        <li class="nav-item" v-for="tab in subTabs" :key="tab.tab" :class="tab.class">
          <router-link :to="tab.link" :class="{ active: tab.link == currentTab }" class="nav-link text-nowrap">
            <i :class="tab.icon" v-if="tab.icon" class="mr-2 d-none"></i>
            <span class>{{ tab.name }}</span>
            <span v-if="tab.badge" class="badge badge-pill badge-primary ml-2 d-inline-block">{{ tab.badge }}</span>
          </router-link>
        </li>
      </ul>
      <router-view></router-view>
      <b-modal
        ref="customerImport"
        title="Import Customers"
        scrollable
        hide-footer
        modal-class="modal right fade"
        dialog-class="modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-lg"
        content-class="no-max-height"
      >
        <CustomerImportCSV @submit="submitImport" @cancel="cancel"></CustomerImportCSV>
      </b-modal>
      <b-modal
        ref="companyImport"
        title="Import Companies"
        scrollable
        hide-footer
        modal-class="modal right fade"
        dialog-class="modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-lg"
        content-class="no-max-height"
      >
        <CompanyImportCSV @submit="submitCompanyImport" @cancel="cancelImportCompany"></CompanyImportCSV>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { PLAN_TOOLS, checkAccess } from '../../utils';
export default {
  data() {
    return {
      tabs: [
        {
          name: 'Follow Ups',
          link: '/customers',
          icon: 'far fa-tasks',
          requiredTools: [PLAN_TOOLS.CUSTOMER[0].value],
          class: 'intro-customer-follow-ups-tab'
        },
        {
          name: 'Customers',
          link: '/customers/all',
          icon: 'far fa-users',
          requiredTools: [PLAN_TOOLS.CUSTOMER[1].value],
          class: 'intro-customer-list-tab'
        },
        {
          name: 'Companies',
          link: '/customers/companies',
          icon: 'far fa-company',
          requiredTools: [PLAN_TOOLS.CUSTOMER[2].value],
          class: 'intro-customer-company-list-tab'
        },
        {
          name: 'Presentations',
          link: '/customers/presentations',
          icon: 'far fa-company',
          requiredTools: [PLAN_TOOLS.CUSTOMER[3].value],
          class: 'intro-customer-presentations-tab'
        },
        {
          name: 'Opportunities',
          link: '/customers/opportunities',
          icon: 'far fa-paint-brush',
          requiredTools: [PLAN_TOOLS.CUSTOMER[6].value],
          class: 'intro-customer-opportunities-tab',
          badge: 'NEW'
        },
        {
          name: 'Proofs',
          link: '/customers/proofs',
          icon: 'far fa-paint-brush',
          requiredTools: [PLAN_TOOLS.CUSTOMER[5].value],
          class: 'intro-customer-proofs-tab'
        },
        {
          name: 'Email',
          link: '/customers/email/lists',
          subTabs: [
            { name: 'Lists', link: '/customers/email/lists' },
            { name: 'Send', link: '/customers/email/send' },
            { name: 'Activity', link: '/customers/email/activity' },
            { name: 'Templates', link: '/customers/email/templates' }
          ],
          icon: 'far fa-envelope',
          requiredTools: [PLAN_TOOLS.CUSTOMER[4].value],
          class: 'intro-customer-email-tab'
        }
      ]
    };
  },
  computed: {
    currentTab() {
      return this.$route.path;
    },
    subTabs() {
      const tab = this.tabs.find(
        (tab) => tab.link == this.currentTab || (tab.subTabs && tab.subTabs.some((st) => st.link === this.currentTab))
      );
      return tab?.subTabs;
    }
  },
  methods: {
    showUpgradePlanIcon(tab) {
      return checkAccess({ requiredTools: tab.requiredTools });
    },
    submitImport() {
      eventBus.$emit('importedCSVCustomers');
      this.notificateSuccess('Successfully imported');
      this.cancel();
    },
    submitCompanyImport() {
      eventBus.$emit('importedCSVCompanies');
      this.notificateSuccess('Successfully imported');
      this.cancelImportCompany();
    },
    showImport() {
      this.$refs.customerImport.show();
    },
    cancel() {
      this.$refs.customerImport.hide();
    },
    showImportCompany() {
      this.$refs.companyImport.show();
    },
    cancelImportCompany() {
      this.$refs.companyImport.hide();
    }
  },
  components: {
    NotificationBar: () => import('@/components/NotificationBar'),
    CustomerImportCSV: () => import('./components/CustomerImportCSV'),
    CompanyImportCSV: () => import('./../Companies/components/CompanyImportCSV')
  }
};
</script>
